// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { BrowserCacheLocation } from '@azure/msal-browser';

export const environment = {
    production: false,
    /**
     * Cache-busting hash for i18n translation files.
     * Generates a unique hash on each application load to prevent stale translations.
     */
    hash: `${new Date().valueOf()}`,
    /** Base URL of the legacy JUNO app (used for project creation until the new flow is ready). */
    legacyAppUrl: 'https://dev.juno.suites.siemens.cloud',
    // TODO: Add your own environment variables here
    msalConfig: {
        auth: {
            clientId: 'b85da876-8f26-472d-abd0-bb8393748196',
            authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a',
            redirectUri: window.location.origin,
            postLogoutRedirectUri: window.location.origin,
            navigateToLoginRequestUrl: true
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage,
            storeAuthStateInCookie: false
        },
        system: {
            allowPlatformBroker: false
        }
    },
    apiConfig: [
        // TODO: Add your own API configurations here
        // this one below is just for fetching the user profile picture shown in the avatar
        // Example configuration is commented out
        // TODO: The monorepo-template needs the User.ReadBasic.All API Permission, so make sure you add it to your Entra API Permissions
        {
            // `User.Read` powers the signed-in user's profile/photo; `Application.Read.All`
            // (delegated) powers the tenant-wide Entra application picker in the
            // client-registration dialog (#150). `Application.Read.All` REQUIRES one-time
            // admin consent per environment (operator action — see
            // docs/getting-started/client-registration.md). The MsalInterceptor attaches a
            // token carrying both scopes to every https://graph.microsoft.com/v1.0 request.
            scopes: ['User.Read', 'Application.Read.All'],
            uri: 'https://graph.microsoft.com/v1.0'
        },
        {
            scopes: [
                'https://api.dev.juno.suites.siemens.cloud/Template.Read',
                'https://api.dev.juno.suites.siemens.cloud/MailJob.ReadWrite'
            ],
            uri: 'https://api.dev.juno.suites.siemens.cloud/*'
        },
        {
            scopes: ['https://api.scd.suites.siemens.cloud/SCD.Read'],
            uri: 'https://api.scd.suites.siemens.cloud/*',
            apiKey: 'tRyzcRl5N25VgoF0XAY7398ZNkgsQJB30fffF1R9'
        }
    ]
};
